export default "__VITE_ASSET__DS1EkiX1__"